// extracted by mini-css-extract-plugin
module.exports = {"root":"InquiryWizardPanel_root__3yiYF"};